import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext } from "react"
import CategoriesContext, { CategoriesContainer } from "~/contexts/Categories"
import usePermissionsRedirect from "~/hooks/usePermissionsRedirect"
import Page from "~/pages/Page"
import Router from "~/router"

const Categories = ({ routes = [], ...rest }) => {
  usePermissionsRedirect("/learning-paths", "categories")

  return (
    <Page>
      <CategoriesContainer>
        <CategoriesWrapper>
          <Router routes={routes} {...rest} />
        </CategoriesWrapper>
      </CategoriesContainer>
    </Page>
  )
}

Categories.propTypes = {
  routes: PropTypes.array,
}

const CategoriesWrapper = ({ children }) => {
  const { categoriesLoading } = useContext(CategoriesContext)
  if (categoriesLoading) {
    return <LinearProgress />
  } else {
    return children
  }
}

CategoriesWrapper.propTypes = {
  children: PropTypes.node,
}

export default Categories
